import { Amplify } from 'aws-amplify';
import { signIn, signOut, getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

export const authService = {
  // Sign in a user
  signIn: async (username: string, password: string) => {
    try {
      const user = await signIn({ username, password });
      return user;
    } catch (error) {
      throw error;
    }
  },

  // Sign out the current user
  signOut: async () => {
    try {
      await signOut();
    } catch (error) {
      throw error;
    }
  },

  // Get the current authenticated user
  getCurrentUser: async () => {
    try {
      const user = await getCurrentUser();
      return user;
    } catch (error) {
      throw error;
    }
  },

  // Get the current session, including tokens
  getCurrentSession: async () => {
    try {
      const session = await fetchAuthSession();
      return session;
    } catch (error) {
      throw error;
    }
  },

  // Check if a user is authenticated
  isAuthenticated: async () => {
    try {
      await getCurrentUser();
      return true;
    } catch (error) {
      return false;
    }
  }
};